<script>
export default {
  name: "AreaContainer",
  computed: {
    envBgClass() {
      const hostname = window.location.hostname;
      if (hostname.includes("localhost")) {
        return "bg-blue-200";
      } else if (hostname.includes("-qa")) {
        return "bg-red-200";
      } else {
        return "bg-gray-100";
      }
    },
  }
}
</script>

<template>
  <div :class="['flex flex-col flex-1 overflow-hidden', envBgClass]">
    <slot />
  </div>
</template>
